import featureToggles from 'shared/featureToggles'
import { formatToGrs } from 'shared/time-utilites'
import { getRequestHeaders } from 'grs/api'
import { PromoCodeError, CreateReservationError } from 'basket/errors'
import { jsonPost } from 'api'

const mapBoletoData = boletoData => {
    if (!boletoData) {
        return {}
    }

    const {
        documentType: CustomerDocumentType,
        documentNumber: CustomerDocumentNumber,
        postalCode: PostalCode,
        street: Street,
        streetNumber,
        district: District,
        city: City,
        state: State,
        complement: Complement,
    } = boletoData

    return {
        BOLETOPAYMENTINFO: {
            CustomerDocumentType,
            CustomerDocumentNumber,
            PostalCode,
            Street,
            Number: streetNumber,
            District,
            City,
            State,
            Complement,
        },
    }
}

const generateReservationList = (items, userDetails, apiLanguageCode, card, boletoData) =>
    items.map(item => {
        const { rate, vehicles, promoCode, autoRenew } = item
        const {
            eDataLocationId: locationId,
            rateId,
            fromDate,
            toDate,
            actualFromDate,
            actualToDate,
            waitingListKey,
            eventId,
        } = rate
        const { id: vehicleId, tag, state } = vehicles[0] || {}
        const { firstName, lastName, emailAddress: email, phone, address, deliveryAddress: delivery } = userDetails

        const { id: ccId, cardLast4, name: ccName, cardType, expDate, token } = card || {}

        return {
            EVENTID: eventId ? eventId : undefined,
            LOC: locationId,
            RATEID: rateId,
            FD: formatToGrs(fromDate),
            TD: formatToGrs(toDate),
            ACTUALFDATE: formatToGrs(actualFromDate),
            ACTUALTODATE: formatToGrs(actualToDate),
            EM: email,
            VEHID: vehicleId,
            LP: tag,
            STATE: state,
            VEHLIST: vehicles.length > 1 ? vehicles.map(parseVehicleData) : null,
            WLKEY: waitingListKey,

            PRMCODE: promoCode ? promoCode.barcode : undefined,
            PRMAMT: promoCode ? promoCode.promoDiscount : undefined,
            ISAUTORNW: autoRenew || false,
            ISOLANGCODE: apiLanguageCode,
            WIDGETKEY: window.WIDGET_KEY || 'Web',

            PKRFNAME: firstName,
            PKRLNAME: lastName,
            PKREMAIL: email,
            PKRMOB: phone,
            PKRADDR1: address.address1,
            PKRADDR2: address.address2,
            PKRCITY: address.city,
            PKRSTATE: address.state,
            PKRZIP: address.postalCode,

            DLVRYNAME: `${firstName} ${lastName}`,
            DLVRYADDR1: delivery.address1,
            DLVRYADDR2: delivery.address2,
            DLVRYCITY: delivery.city,
            DLVRYSTATE: delivery.state,
            DLVRYZIP: delivery.postalCode,

            CCID: ccId,
            CRDLAST4: cardLast4,
            CRDNAME: ccName,
            CRDTYPE: cardType,
            EXP: expDate,
            ...mapBoletoData(boletoData),
            ...(featureToggles.newAuthFlow ? { PN: token } : {}),
        }
    })

const parseVehicleData = ({ id, state, tag, name, color, make, model }) => ({
    ID: id,
    STATE: state,
    TAG: tag,
    NAME: name,
    COLOR: color,
    MAKE: make,
    MODEL: model,
    VEHID: id,
})

export const redeemPromoCode = (item, rawPromoCode, apiLanguageCode = 'EN', token) => {
    const { eDataLocationId: locationId, rateId, fromDate, toDate, actualFromDate, actualToDate } = item.rate

    const ReservationInfoData = {
        ACTUALFDATE: formatToGrs(actualFromDate),
        ACTUALTODATE: formatToGrs(actualToDate),
        LOC: locationId,
        RATEID: rateId,
        FD: formatToGrs(fromDate),
        TD: formatToGrs(toDate),
        PRMCODE: rawPromoCode,
        ISOLANGCODE: apiLanguageCode,
    }

    if (token) {
        ReservationInfoData.TOKEN = token
    }
    return jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/RedeemPromoCode`,
        {
            ReservationInfoData,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new PromoCodeError(error.message)
    })
}

export const createReservation = (
    token,
    items,
    userDetails,
    apiLanguageCode = 'EN',
    card,
    boletoData,
    recaptchaToken
) =>
    jsonPost(
        `${GRS_RESERVATIONS_SERVICE}/CreateCartLoginReservationJSONPOST`,
        {
            ReservationInfoList: generateReservationList(items, userDetails, apiLanguageCode, card, boletoData),
            Token: token,
            SCKEY: WIDGET_TYPE,
            ISOLANGCODE: apiLanguageCode,
            'g-recaptcha-response': recaptchaToken,
        },
        {
            ...getRequestHeaders(apiLanguageCode),
        }
    ).catch(error => {
        throw new CreateReservationError(error.message)
    })
